import React, { Component } from 'react';
import { connect } from 'react-redux';

import AllowTabs from '../../allow_tabs/AllowTabs';
import axios from 'axios'
import WEB_API  from '../../../../API/api';
import * as action from '../action'
import { ASSIST, PAPER, KNOWLEDGEWITHISSUE } from '../../../../utils/questionManageType';
import '../../style.less'
import { Layout, Button, Alert,  Icon,Pagination ,message,Modal,Row,Tag,Checkbox,Rate,Select} from 'antd';

import * as Types from './../../../../utils/questionType'
import {view as EditDelQuestionManage} from '../editDelQuestionManage'
import Question from '../../../../entry_question_editor/question/question_view/view';

import {PropTypes} from 'prop-types';
import KnowledgeBox from '../../set_tag/question_tag_detail/knowledge_box/view'
const { Header, Footer, Sider, Content } = Layout;


class LookOverQuestion extends Component {
    static propTypes = {
        // name: PropTypes.string
    }
    static contextTypes = {
        router: PropTypes.object.isRequired
    };
    state = {
        collapsed: false,//侧边栏隐藏

        assist_id:'-1',
        knowList: [],
        know_id: -1,
        section_id: -1,
        paper_id: "",
        relate_id:"",
        questionListType: ASSIST,
        type:ASSIST,
        selectedQuestion:[],
        page: 1,
        pagesize: localStorage.getItem('questionlist_pagesize')||20,



        isGetQuestionListFetching: false,
        isGetTreeListFetching: false,
        isGetTypeListFetching:false,

        typeList: {},
        treeList:{},
        assistList: {},
        assistQuestionFilterList: {},
        error:'',

    }
    componentDidMount(){
        // if(this.props.shopcar.length<1){
        //     this.context.router.history.push(`../lookoverquestion`);
        // }

        const {   defaultAssistList  } = this.state;
        let questionList = this.props.questionList
        questionList.list =[]
        this.props.setQuestionList(questionList)//设为空
        this.getQuestionList(this.state.page,this.state.pagesize);

        //跳到购物车保留左侧树
        if(this.props.typeList.source){
            this.setState({typeList:this.props.typeList})
        }
        if(this.props.assistList){
            this.setState({assistList:this.props.assistList})
        }
        if(this.props.treeList){
            this.setState({treeList:this.props.treeList})
        }
        if(this.props.defaultAssistList&&this.props.defaultAssistList.length){
            this.setState({defaultAssistList:this.props.defaultAssistList})
        }//教辅版本选中数据
        else{
            this.setState({defaultAssistList:[]})
        }
        // this.getTypeList(()=> this.getNoSubjectAssistList());
        // if (defaultAssistList.length > 2) {
        //     this.setState({assist_id: defaultAssistList[defaultAssistList.length - 1]});
        // }
    }
    componentDidUpdate(){
        // if(this.props.shopcar.length<1){
        //     this.context.router.history.push(`../lookoverquestion`);
        // }
    }
    createHtml = str => ({ __html: str ? str : `&nbsp;` });

    onCollapse = (collapsed) => {
        collapsed = !collapsed
        this.setState({ collapsed });
    }
    /*获得tab的list*/
    getTypeList=(callback)=>{
        this.setState({isGetTypeListFetching:true})
        axios.post(WEB_API.GET_TYPE_LIST,{}).then((res)=>{
            res = res.data
            if (res.code === 0) {
                this.setState({ typeList: res.data,isGetTypeListFetching:false});
                callback()
            }else{
                this.setState({error:res.message})
            }
        },(error)=>{
            message.error('网络错误！');
        });
    }
    /*获得教材列表*/
    getNoSubjectAssistList=()=>{
        axios.post(WEB_API.GET_NO_SUBJECT_ASSIST_LIST,{}).then((res)=>{
            res = res.data
            if (res.code === 0) {
                this.setState({ assistList: res.data});
            }else{
                message.error(res.message);
            }
        },(error)=>{
            message.error('网络错误！');
        });
    }
    /*级联选择器选择教材*/
    handleAssistChange = (value, selectedOptions) => {
        let { assist_id } = this.state;
        if (value.length === 3) {
            this.setState({ defaultAssistList: value });
            if (assist_id == value[value.length-1]) return;
            assist_id = value[value.length-1];
            this.setState({assist_id});
            this.handleGetTreeList(ASSIST, value[value.length-1]);
        }
    }
    /*获得章节的信息*/
    handleGetTreeList = (type, rootId) => {
        if (type == PAPER) return this.getTreeList({ type, rootId: 0, page: 1, pagesize: this.state.pagesize });
        this.getTreeList({ type, rootId: type == ASSIST ? rootId : 0 });

    }
    /*获得树*/
    getTreeList = (data) => {
        axios.post(WEB_API.GET_TREE_LIST,data).then((res)=>{
            res = res.data
            if (res.code === 0) {
                this.setState({ treeList: Object.assign(this.state.treeList,{[res.data.type]:  res.data})});
            }else{
                message.error(res.message);
            }
        },(error)=>{
            message.error('网络错误！');
        });
    }

    /*选择了章节树的节点*/
    handleTreeSelect = (selectedKeys, type) => {
        if(selectedKeys.length==0){return}
        this.setState({questionListType: type});
        switch (type) {
            case ASSIST:
                const { assist_id } = this.state;
                this.setState({  assist_id, section_id: selectedKeys[0], know_id: -1, issue_id: "", paper_id: "" });
                break;
            case PAPER:
                this.setState({  section_id: '', know_id: -1, paper_id: selectedKeys[0], issue_id: "" });
                break;
            case KNOWLEDGEWITHISSUE:
                this.setState({  section_id: '', know_id: selectedKeys[0], issue_id: "", paper_id: "" });
                break;
            default:
                // statements_def
                break;
        }
        this.setState({relate_id: selectedKeys[0], type});
    }

    /*获取题目列表*/
    getQuestionList = (page=this.state.page,pagesize=this.state.pagesize,callback) => {
        this.setState({isGetQuestionListFetching:true})
        let data = {
            question_ids:this.props.shopcar,
            page,
            pagesize
        }

        axios.post(WEB_API.QUESTION_BY_ID,data).then((res)=>{
            res = res.data
            if (res.code === 0) {
                this.props.setQuestionList(res.data)
                this.setState({ isGetQuestionListFetching:false});
                callback&&callback()
            }else{
                message.error(res.message);
                this.setState({isGetQuestionListFetching:false})
            }
        },(error)=>{
            message.error('网络错误！');
        });
    }
    pageChange = (page,pagesize) => {
        this.setState({page, pagesize});
        this.getQuestionList(page, pagesize);
        document.body.scrollIntoView();
    }

    pagesizeChange = (page, pagesize) => {
        this.setState({page, pagesize});
        localStorage.setItem('questionlist_pagesize',pagesize)
        this.getQuestionList(page, pagesize);
    }

    handleTableChange = key => {
        if (key != ASSIST) {
            this.handleGetTreeList(key);
        }
        this.setState({questionListType: key});
    }

    getPaperTreeList = (page, pagesize) => {
        this.getTreeList({ page, pagesize, type: PAPER, rootId: 0 });
    }


    refreshQuestionList=()=>{
        this.getQuestionList(this.state.page,this.state.pagesize);
    }
    handleExport = (is_del=0) => {
        const {shopcar  } = this.props;
        const { questionListType, relate_id } = this.state;
        if(relate_id===''){message.error('请选择节点');return}
        let question_ids = []
        shopcar.forEach(d=>{
            if(this.state.selectedQuestion.some(item=>item==d.question_id)){
                question_ids.push(d)
            }
        })
        let data = {
            question_ids: question_ids,
            type: questionListType,
            rootId: relate_id,
            is_del
        }
        axios.post(WEB_API.COPY_SELECT_QUESTION,data).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success("导题成功");
                // this.props.setShopcar([]);
                this.delShoppingQuestion()
            }else{
                message.error(res.message);
            }
        },(error)=>{
            message.error('网络错误！');
        });
    }

    delShoppingQuestion = () => {//
        let { shopcar } = this.props;
        shopcar = [...shopcar]
        this.state.selectedQuestion.forEach((id)=>{
            if (shopcar.some(d=>d.question_id==id)){
                shopcar.splice(shopcar.findIndex(d=>d.question_id==id), 1)
            }
        })
        this.props.setShopcar(shopcar);
        this.selectAllQuestionNo()//清空被删题目
        setTimeout(()=>{
            this.getQuestionList()
        },0)
    }
    changeSelectedQuestion= (arr) => {//
        let selectedQuestion = [...this.state.selectedQuestion]
        arr.forEach((id)=>{
            if (selectedQuestion.indexOf(id) > -1)
                selectedQuestion.splice(selectedQuestion.indexOf(id), 1)
            else{
                selectedQuestion.push(id);
            }
        })
        this.setState({selectedQuestion})
    }
    selectAllQuestion= () => {//
        let { shopcar } = this.props;
        let selectedQuestion = [...shopcar]

        selectedQuestion = selectedQuestion.map(d=>d.question_id)
        this.setState({selectedQuestion})
    }
    selectAllQuestionNo= () => {//全不选
        let selectedQuestion = []
        this.setState({selectedQuestion})
    }
    setTagBatch=()=>{

        let question = this.props.questionList.list[0]
        let question_id = question&&question.question_id
        if(question_id){
            let data = {
                question_id:question_id,
            }
            axios.post(WEB_API.QSELECTTNEW_QUESTION_DETAIL,data).then((res)=>{
                res = res.data
                if (res.code === 0) {
                    this.setState({setTagVisible:true,
                        select:res.data.select,
                        displaytypelist:res.data.displaytypelist,
                        display_type:res.data.display_type,
                        difficulty:res.data.difficulty,
                    })
                }else{
                    message.error(res.message);
                }
            },(error)=>{
                message.error('网络错误！');
            });
        }
    }
    setTagBatchSave = (cb)=>{
        let URL = WEB_API.QSELECTTNEW_TASK_QUESTION_BATCH_SUBMIT

        let relate_list = []
        this.state.select.forEach((val)=>{
            let obj = {
                type:val.type,
                list:val.selected.map(d=>({well:d.well,id:d.id}))
            }
            relate_list.push(obj)
        })
        let data = {
            question_id_list:this.state.selectedQuestion,
            relate_list:relate_list,
            display_type:this.state.display_type,
            difficulty:this.state.difficulty,
        }
        axios.post(URL,data).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success(res.message);
                cb&&cb()
            }else{
                message.error(res.message);
            }
        },(error)=>{
            message.error('网络错误！');
        });

    }
    render() {
        const  {
            collapsed,

            isGetQuestionListFetching,
            isGetTreeListFetching,
            isGetTypeListFetching,

            page,
            pagesize,
            typeList,
            assistList,
            treeList,
            defaultAssistList,
            error,
        } = this.state
        const {questionList} = this.props
        const { total, list } = questionList;
        return (
            <div className="summary_wrap" id="summary_wrap"  style={{paddingLeft:'10px',position:'relative'}}>
                {
                    !!error && <Alert style={{margin:'10px 0'}} message= { error } closable type="error" showIcon />
                }
                <div>
                    <div style={{position:'absolute',left:'-10px',top:200}} onClick={()=>{this.onCollapse(collapsed)}}>
                        <div style={{display:'block',height:'20px',width:'14px',background:'#f3f3f3',cursor:'pointer'}}>
                            {
                            collapsed
                            ?
                                <Icon type="right" />
                            :
                                <Icon type="left" />
                            }
                    </div>
                    </div>
                </div>
                <Layout>

                    <Sider className={`slideLeft ${collapsed?'close':'open'}`}>
                            <div style={{position:'fixed'}}>
                            {
                                !isGetTypeListFetching && typeList.source &&
                                <AllowTabs
                                    size = "small"
                                    data = { typeList.source }
                                    handleTableChange = { this.handleTableChange }
                                    handleAssistChange = { this.handleAssistChange }
                                    handleTreeSelect = { this.handleTreeSelect }
                                    assistList = { assistList }
                                    loading = { isGetTreeListFetching }
                                    treeList = { treeList }
                                    defaultAssistList = { defaultAssistList }
                                    handleGetPaperTreeList = { this.getPaperTreeList }
                                    expandedKeys={this.props.expandedKeys}
                                />
                            }
                            </div>
                    </Sider>
                    <Layout>
                        <Header style={{overflow:"hidden"}}>
                            <div style={{fontSize:"18px", float:"left"}}>
                                已选题目列表
                            </div>

                        </Header>
                        <Content>
                            <div style={{overflow:"hidden",marginBottom:20}}>
                                <Button onClick={()=>{window.history.go(-1)}} style={{marginRight: 20, float:"right"}}>
                                    返回
                                </Button>
                                <Button disabled={!this.state.selectedQuestion.length} type= "danger" style={{marginRight: 20, float:"right"}} onClick= { () => this.delShoppingQuestion() }>
                                    从购物车移除
                                </Button>
                                {
                                    this.props.role_qshow.importQuestionFromShopping >0&&
                                    <Button disabled={!this.state.selectedQuestion.length} type="primary" onClick= { ()=>this.handleExport(0) } style={{marginRight: 20, float:"right"}}>
                                        导入题目
                                    </Button>
                                }
                                {
                                    this.props.role_qshow.importQuestionFromShopping >0&&
                                    <Button disabled={!this.state.selectedQuestion.length} type="primary" onClick= { ()=>{this.handleExport(1)} } style={{marginRight: 20, float:"right"}}>
                                        导入并删除原关联
                                    </Button>
                                }
                                {
                                    this.props.user.role_qselect&&this.props.user.role_qselect.select===1 &&
                                    <Button disabled={!this.state.selectedQuestion.length} type="primary" onClick= { ()=>{this.setTagBatch()} } style={{marginRight: 20, float:"right"}}>
                                        打标签
                                    </Button>
                                }


                                <Modal title="打标签" disabled={!this.state.selectedQuestion.length} visible={this.state.setTagVisible} onOk={()=>{this.setTagBatchSave( ()=>{this.setState({setTagVisible: false})} )}}
                                       okText={'保存'}
                                       onCancel={() => this.setState({setTagVisible: false})}>
                                    {
                                        <Row>
                                            <span style={{fontSize:13}}>题目难度：</span>
                                            <span>
                                        <Rate  onChange= {(val)=>{this.state.difficulty=val;this.forceUpdate()}}  value={ +this.state.difficulty||1 }count={4}/>
                                        </span>
                                        </Row>
                                    }

                                    {
                                        <Row>
                                            <span style={{fontSize:13}}>展示类型：</span>
                                            <span>
                                        {
                                            this.state.displaytypelist&&
                                            <Select  value={''+this.state.display_type} style={{width: 80, marginLeft: 5}} onSelect={(val)=>{this.state.display_type=val;this.forceUpdate()}}>
                                                {
                                                    this.state.displaytypelist.map((val,k)=>
                                                        <Select.Option key={k} value={val.id}>{val.name}</Select.Option>
                                                    )
                                                }
                                            </Select>
                                        }
                                    </span>
                                        </Row>
                                    }
                                    {
                                        this.state.select&&this.state.select.length&&
                                        this.state.select.map((val,k)=>
                                            <Row key={k}>
                                                <KnowledgeBox data={val}
                                                              select={this.state.select}
                                                              isTask={'noTask'}
                                                ></KnowledgeBox>
                                            </Row>
                                        )

                                    }
                                </Modal>

                                <Button type="primary" onClick= { ()=>{this.selectAllQuestion()} } style={{marginRight: 20}}>
                                    全选
                                </Button>

                                <Button type="" onClick= { ()=>{this.selectAllQuestionNo()} } style={{marginRight: 20}}>
                                    反选
                                </Button>
                            </div>
                            {
                                !!list.length ?
                                    list.map((v, k) =>
                                        <div key={v.question_id} style={{marginBottom: '30px',position:'relative',paddingLeft:'20px'}}>
                                            <div  style={{position:'absolute',left:'2px'}}>
                                                <Checkbox checked={this.state.selectedQuestion.some(d=>d==v.question_id)} onChange={()=>{this.changeSelectedQuestion([v.question_id])}}></Checkbox>
                                            </div>
                                            <div className={'question'}>
                                                {/*返工原因展示*/}
                                                {v.mark &&v.mark!==''&&
                                                <div style={{textAlign:'center',fontSize:'15px',marginBottom:'15px'}}>
                                                    <Tag color="#f50" style={{fontSize:14}}><span>返工原因：</span><span>{v.mark}</span></Tag>
                                                </div>
                                                }
                                                <Question data={v}  num={(page-1)*pagesize+k}/>

                                            </div>

                                        </div>
                                    ) :
                                    <div style={{fontSize: "16px", height: "30px", marginBottom: "50px"}}>
                                        <p style={{paddingTop: 15, paddingLeft: 50, color: 'green'}}>暂无题目</p>
                                    </div>
                            }
                        </Content>
                        <Footer>
                            {
                                !!list.length &&
                                <Pagination
                                showQuickJumper
                                showSizeChanger
                                pageSize={+this.state.pagesize}
                                total={+total}
                                onChange={ this.pageChange }
                                onShowSizeChange = { this.pagesizeChange }
                                current={page?(+page):1}
                                />
                            }

                        </Footer>
                    </Layout>
                </Layout>
            </div>
        )
    }
}

function mapState(state) {
    return {
        questionList:state.questionManage.lookOverQuestion.questionListShopcar,
        shopcar:state.questionManage.lookOverQuestion.shopcar,
        role_qshow:state.user.role_qadmin?state.user.role_qadmin.role_qshow:false,
        user:state.user,

        typeList:state.questionManage.lookOverQuestion.typeList,
        assistList:state.questionManage.lookOverQuestion.assistList,
        treeList:state.questionManage.lookOverQuestion.treeList,
        expandedKeys:state.questionManage.lookOverQuestion.expandedKeys,
        defaultAssistList:state.questionManage.lookOverQuestion.defaultAssistList,
    };
}

function mapDispatch(dispatch) {
    return{
        setQuestionList:(data)=>{
            dispatch(action.setQuestionListShopcar(data))
        },
        setShopcar:(data)=>{
            dispatch(action.setShopcar(data))
        },
    }
}
export default connect(mapState, mapDispatch)(LookOverQuestion);


// WEBPACK FOOTER //
// ./src/entry_app/question_manage/look_over_question/question_car/view.js